export enum TDStoreValidatorTypeEnum {
  STORE_CODE = 'storeCode',
  STORE_NAME = 'storeName',
  TAX_ID = 'taxId',
  ID_CARD = 'idCard',
  MOBILE_PHONE = 'mobilePhone',
  REQUESTED = 'requested'
}
